const defaults = () => ({
  extendedCoursePrompt: '',
});

export default {
  namespaced: true,
  persist: ['extendedCoursePrompt'],
  state: defaults,
  mutations: {
    HYDRATE(state, payload) {
      Object.assign(state, payload);
    },
    SET_EXTENDED_COURSE_PROMPT(state, value) {
      state.extendedCoursePrompt = value;
    },
    RESET(state) {
      Object.assign(state, defaults());
    },
  },
};
